import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import AddKinerjaHarianPage from 'app/KinerjaHarian/pages/AddEditKinerjaHarianLogs'
import { KinerjaTipeProvider } from 'app/KinerjaShared/components/KinerjaTipeProvider'
import PageGuardKs from 'app/KinerjaKSPage/components/PageGuardKs'
import { PageGuardKinerjaHarian } from 'app/KinerjaHarian/components/PageGuardKinerjaHarian'
import { KinerjaHarianRoleProvider } from 'app/KinerjaHarian/components/KinerjaHarianRoleProvider'
import {
  PENGELOLAAN_KINERJA_KS_PEGAWAI_PATH,
  PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
} from 'app/KinerjaShared/constants/path'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isKinerjaEnabled = toggle?.['kinerja-enabled'] || false
    const isKinerjaHarianEnabled = toggle?.['kinerja-harian-enabled'] || false

    if (!isKinerjaEnabled || !isKinerjaHarianEnabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }

    return { props: {} }
  },
})

export default function Page() {
  return (
    <KinerjaTipeProvider tipe="SPF">
      <KinerjaHarianRoleProvider role="KS">
        <PageGuardKs>
          <PageGuardKinerjaHarian>
            <AddKinerjaHarianPage
              basePath={`${PENGELOLAAN_KINERJA_KS_PEGAWAI_PATH}/harian`}
            />
          </PageGuardKinerjaHarian>
        </PageGuardKs>
      </KinerjaHarianRoleProvider>
    </KinerjaTipeProvider>
  )
}

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  className: 'text-default !max-w-full min-h-screen',
  forceResolution: true,
}
